import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import { observable, action, toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { observation as api } from '../../actions/api';
import { getDisplayDate } from '../../libs/date';
import Spinner from "../Spinner";
import Form, { FormBody, FormActions, SelectInput, DateInput } from "../Form";
import moment from 'moment';
import GraphView from '../GraphView';

@inject('stationStore', 'parameterStore')
@observer
class MonitoringTabular extends Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };

  @observable filters = {
    station_id: null,
    series_id: null,
    date_from: moment().format('YYYY-MM-DD'),
    date_to: moment().add(1, 'days').format('YYYY-MM-DD'),
  };
  @observable dataSeriesItems = [];
  @observable options = null;
  @observable isLoading = false;

  componentWillMount() {
    const { stationStore, parameterStore } = this.props;

    if (!stationStore.isLoading && !stationStore.items.length) stationStore.fetchItems();
    if (!parameterStore.isLoading && !parameterStore.items.length) parameterStore.fetchItems();
  }

  @action onChangeFilter = (field, value) => {
    this.filters[field] = value;
    if (field === 'station_id' && (!!value && value != -1)) {
      const { notify } = this.context;
      const { stationStore, parameterStore } = this.props;

      stationStore.fetchDataSeries(value)
        .then(action(dataSeriesItems => {
          this.dataSeriesItems = dataSeriesItems
            .sort((a, b) => a.name > b.name ? 1 : -1)
            .map(item => (Object.assign(item, { parameter: parameterStore.findById(item.parameter_id) })));
        }))
        .catch(notify.error);
    }
  }

  makeRequest = (e) => {
    e.preventDefault();
    const { notify } = this.context;

    this.options = null;
    this.isLoading = true;
    api.fetchIndex(this.filters)
      .then(res => {
        let dataWithUniqueTime = [];
        let groupedData = _.groupBy(res, item => item.time);
        Object.keys(groupedData).forEach(key => {
          const data = groupedData[key];
          let dataWithMaxTimestamp = null;
          data.forEach(item => {
            if (!dataWithMaxTimestamp || moment(item.timestamp).isAfter(moment(dataWithMaxTimestamp.timestamp))) {
              dataWithMaxTimestamp = item;
            }
          });
          dataWithUniqueTime.push([
            getDisplayDate(dataWithMaxTimestamp.time, { returnMills: true }),
            Math.floor((moment(dataWithMaxTimestamp.timestamp).valueOf() - moment(dataWithMaxTimestamp.time).valueOf()) / 60000)
          ]);
        });
        return dataWithUniqueTime;
      })
      .then(res => {
        let selectedSeries = this.dataSeriesItems.find(item => item.id == this.filters.series_id)
        this.options = {
          chart: {
            type: 'column',
            zoomType: 'x',
          },
          title: {
            text: 'Delay',
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%H:%M',
              day: '%Y-%m-%d',
              month: '%Y-%m',
              year: '%Y'
            },
          },
          yAxis: {
            title: {
              text: 'minutes',
            },
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [{
            name: selectedSeries.name,
            data: res.sort((a, b) => a[0] < b[0] ? -1 : 1)
          }],
        };
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        notify.error(err);
      })
  }

  render() {
    const { stationStore, parameterStore } = this.props;

    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput
              label={'Station'}
              value={this.filters.station_id}
              fields={{ label: 'name', value: 'id' }}
              options={stationStore.items}
              onChange={e => this.onChangeFilter('station_id', e.target.value)}
              filterOptions={stationStore.filterStations}
            />
            <SelectInput
              label={'Data Series'}
              value={this.filters.series_id}
              fields={{ label: 'name', value: 'id' }}
              options={this.dataSeriesItems}
              onChange={e => this.onChangeFilter('series_id', e.target.value)}
              filterOptions={(options, filterText) => parameterStore.filterParameters(options, filterText, 'parameter.code')}
            />
            <DateInput
              label={'Date From'}
              value={this.filters.date_from}
              onChange={e => this.onChangeFilter('date_from', e.target.value)}
            />
            <DateInput
              label={'Date To'}
              value={this.filters.date_to}
              onChange={e => this.onChangeFilter('date_to', e.target.value)}
            />
          </FormBody>
          <FormActions>
            <button onClick={this.makeRequest}>View</button>
          </FormActions>
        </Form>

        <div>
          {this.isLoading && <Spinner />}
          {!this.isLoading && this.options && <GraphView options={toJS(this.options)} />}
        </div>

      </div>
    );
  }
}

export default MonitoringTabular;



// WEBPACK FOOTER //
// ./src/components/Monitoring/MonitoringRealTIme.js